/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowDebtorCollectionQueryResponse, GetShowDebtorCollectionPathParams, GetShowDebtorCollectionQueryParams, GetShowDebtorCollection401, GetShowDebtorCollection403 } from "../../models/GetShowDebtorCollection";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowDebtorCollectionUrl({ debtorCode, uuid }: { debtorCode: GetShowDebtorCollectionPathParams["debtorCode"]; uuid: GetShowDebtorCollectionPathParams["uuid"] }) {
  const res = { method: 'GET', url: `/api/v1/debtors/${debtorCode}/collections/${uuid}` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/collections/:uuid}
 */
export async function getShowDebtorCollection({ debtorCode, uuid, params }: { debtorCode: GetShowDebtorCollectionPathParams["debtorCode"]; uuid: GetShowDebtorCollectionPathParams["uuid"]; params: GetShowDebtorCollectionQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowDebtorCollectionQueryResponse, ResponseErrorConfig<GetShowDebtorCollection401 | GetShowDebtorCollection403>, unknown>({ method : "GET", url : getGetShowDebtorCollectionUrl({ debtorCode, uuid }).url.toString(), params, ... requestConfig })  
  return res.data
}